import { FormValidation, FieldValidation } from '@rjsf/core';

export const validateSocialSecurity = <T extends Record<string, unknown>>(formData: T, errors: FormValidation, propertyFunc: (obj: T | FormValidation) => FieldValidation | string) => {
	try {
		let val = propertyFunc(formData) as string;
		val = val?.replace(/\D/g, '');
		//either empty string or actual phone number
		// i dont care about empty string because html5 validation takes care of it in case of required field
		if (val?.length < 9) {
			// so i made an assumption where if val returns, errror obj also returns...
			// in case i forget
			const errorObj = propertyFunc(errors) as FieldValidation;
      errorObj?.addError('Please enter valid social security number');
      errors.addError('Please enter valid social security number');
		}
	} catch {
		//Point of human error: Either typo or the field is not mapped to the location provided
		//e.g. Method searches in obj.firstLevel.fieldName when it is located in obj.firstLevel.secondLevel.fieldName
		//console.log('Property field is not found at location');
	}
};